import { useState } from 'react';
import { useRouter } from 'next/router';

import Layout from '@layout/index';
import MortgageCalculatorEnhanced from '@components/calculators/mortgage-calculator-enhanced';
import AffordabilityCalculator from '@components/calculators/affordability-calculator';
import RefinanceCalculator from '@components/calculators/refinance-calculator';
import RentVsBuyCalculator from '@components/calculators/rent-vs-buy-calculator';
import interestRatesData from '@data/interest-rates.json';

const RefinanceCalculatorPage = () => {
  const router = useRouter();
  const [currentCalculator, setCurrentCalculator] = useState('refinance');

  const calculatorOptions = [
    { label: 'Mortgage calculator', value: 'mortgage' },
    { label: 'Affordability calculator', value: 'affordability' },
    { label: 'Refinance calculator', value: 'refinance' },
    { label: 'Rent vs. buy calculator', value: 'rent-vs-buy' }
  ];

  const currentRates = {
    15: interestRatesData['15'],
    30: interestRatesData['30']
  };

  const lastUpdatedOn = interestRatesData.lastUpdatedOn;

  const handleCalculatorChange = (calculatorType) => {
    setCurrentCalculator(calculatorType);
    router.push(`/calculators/${calculatorType}`, undefined, { shallow: true });
  };

  const renderCalculator = () => {
    switch (currentCalculator) {
      case 'mortgage':
        return (
          <MortgageCalculatorEnhanced
            calculatorOptions={calculatorOptions}
            onCalculatorChange={handleCalculatorChange}
            currentRates={currentRates}
            lastUpdatedOn={lastUpdatedOn}
          />
        );
      case 'affordability':
        return (
          <AffordabilityCalculator
            calculatorOptions={calculatorOptions}
            onCalculatorChange={handleCalculatorChange}
            currentRates={currentRates}
          />
        );
      case 'rent-vs-buy':
        return (
          <RentVsBuyCalculator
            calculatorOptions={calculatorOptions}
            onCalculatorChange={handleCalculatorChange}
            currentRates={currentRates}
          />
        );
      case 'refinance':
      default:
        return (
          <RefinanceCalculator
            calculatorOptions={calculatorOptions}
            onCalculatorChange={handleCalculatorChange}
            currentRates={currentRates}
          />
        );
    }
  };

  return (
    <Layout
      metaData={{
        title: 'Refinance Calculator | Sibcy Cline',
        description:
          'See if refinancing your mortgage makes sense. Calculate potential monthly savings and break-even points.'
      }}
    >
      {renderCalculator()}
    </Layout>
  );
};

export default RefinanceCalculatorPage;
